import styled from 'styled-components';

interface Props {
  islast?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  
  padding-block: 20px;  
  gap: 20px;
`;

export const InfoContainer = styled.div`
font-weight: 700;
  cursor: pointer;
  @media (max-width: 1024px) {
    width: 60%;
    padding: 30px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 20px;
  }
`;

export const OrderHeader = styled.div`
  background-color: ${props => props.theme.colors.card};
  border-radius: 10px;

  padding: 10px;

  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
`;

export const OrderDetails = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const OrderItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 5px;
    
  & > * {
    flex: 1;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HeaderTitle = styled.span`
  font-weight: 700;
  color: ${props => props.theme.colors.text};
`;

export const ContentTitle = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: ${props => props.theme.colors.text};
`;

export const ContentSubtitle = styled.span`
  font-size: 16px;
  color: ${props => props.theme.colors.text};
`;

export const PedidoWrapper = styled.div<Props>`
  border: 1px solid;
  border-color: ${props => props.theme.colors.border_grey};
  border-bottom-left-radius: ${props => props.islast && '20px'};
  border-bottom-right-radius: ${props => props.islast && '20px'};
`;

export const PedidoContent = styled.div`
  padding: 20px;
  padding-inline: 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PedidoFooter = styled.div`
`;

export const Link = styled.span`
  white-space: pre-wrap;
  font-size: 14px;
  color: ${props => props.theme.colors.primary};
  transition: 200ms;
  align-self: flex-end;
  cursor: pointer;
`